import { styles } from './UiKitTypographyBase.styles';

export interface UiKitTypographyBaseProps {
  children?: React.ReactNode | string;
  /**
   * The HTML tag to render the component as.
   * @default 'article'
   */
  as?: React.ElementType;
  className?: string;
}

export function UiKitTypographyBase({
  children,
  as = 'article',
  className
}: UiKitTypographyBaseProps) {
  const slots = styles();
  const Component = as;

  if (typeof children === 'string') {
    return (
      <Component
        className={slots.base({ className })}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    );
  }

  return (
    <Component className={slots.base({ className })}>{children}</Component>
  );
}
